<ion-content>
  <div>
    <div class="flex-space-between" style="padding: 15px 5px 0 3px">
      <div class="button-container">
        <ion-searchbar
          mode="ios"
          class="rounded-search-bar"
          placeholder="Search members..."
          showCancelButton="never"
          (ionChange)="handleFilters()"
          [(ngModel)]="searchText"
        >
        </ion-searchbar>
        <div [hidden]="!selectedMembers.length">
          <ion-button (click)="sendMessage()" [disabled]="isLoading">
            <ion-icon name="mail-outline"></ion-icon>
            <span class="text-with-left-icon hidden-sm"> Send email </span>
          </ion-button>
          <ion-button fill="outline" (click)="showMemberOptions()" [disabled]="isLoading">
            <span class="text-with-right-icon hidden-sm"> Edit </span>
            <ion-icon name="chevron-down-outline"></ion-icon>
          </ion-button>
          <ion-button fill="clear" color="dark" (click)="selectedMembers = []" [disabled]="isLoading">
            Clear selection
          </ion-button>
        </div>
      </div>
      <div class="button-container" [hidden]="selectedMembers.length">
        <ion-button
          *ngIf="isSuperAdmin || isDev"
          fill="clear"
          color="dark"
          (click)="syncChannel()"
          [disabled]="isLoading"
          class="hidden-sm"
        >
          <ion-icon name="sync-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Sync Members </span>
        </ion-button>
        <ion-button fill="clear" color="dark" (click)="downloadMembers()" [disabled]="isLoading" class="hidden-sm">
          <ion-icon name="cloud-download-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Download CSV </span>
        </ion-button>
        <ion-button fill="dark" color="dark" (click)="sendMessage()" [disabled]="isLoading">
          <ion-icon name="mail-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Send email </span>
        </ion-button>
        <ion-button color="dark" (click)="addAgent()" [disabled]="isLoading">
          <ion-icon name="add-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Add agent </span>
        </ion-button>
      </div>
    </div>
    <div style="padding: 5px 16px 0">
      <ion-button
        class="btn-small"
        [fill]="memberTypeFilter === 'all' ? 'solid' : 'clear'"
        [color]="memberTypeFilter === 'all' ? 'light' : 'dark'"
        (click)="memberTypeFilter = 'all'; handleFilters()"
      >
        All
      </ion-button>
      <ion-button
        class="btn-small"
        [fill]="memberTypeFilter === 'agents' ? 'solid' : 'clear'"
        [color]="memberTypeFilter === 'agents' ? 'light' : 'dark'"
        (click)="memberTypeFilter = 'agents'; handleFilters()"
      >
        Agents
      </ion-button>
      <ion-button
        class="btn-small"
        [fill]="memberTypeFilter === 'customers' ? 'solid' : 'clear'"
        [color]="memberTypeFilter === 'customers' ? 'light' : 'dark'"
        (click)="memberTypeFilter = 'customers'; handleFilters()"
      >
        Customers
      </ion-button>
    </div>
  </div>

  <ion-card class="outline-card">
    <ngx-datatable
      class="material"
      [columnMode]="ColumnMode.force"
      [limit]="100"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="50"
      [scrollbarH]="true"
      [rows]="filteredMembers"
      [selected]="selectedMembers"
      [selectionType]="SelectionType.checkbox"
      [selectAllRowsOnPage]="false"
      [displayCheck]="false"
      [reorderable]="true"
      (select)="onSelect($event)"
    >
      <ngx-datatable-column
        [width]="30"
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
        [headerCheckboxable]="true"
        [checkboxable]="true"
      >
      </ngx-datatable-column>
      <ngx-datatable-column name="Name" [minWidth]="250" prop="user.name">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span *ngIf="row.userId">
            <a (click)="viewProfile(row)">{{row.user?.name}}</a>
          </span>
          <span *ngIf="!row.userId"> {{row.user?.name}} </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Email" [minWidth]="250" prop="user.email">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span> {{row.user?.email}} </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Role" [maxWidth]="170" [minWidth]="170" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge color="success" *ngIf="row.user && row.user.isExternal">Customer</ion-badge>
          <ion-badge color="dark" *ngIf="row.user && !row.user.isExternal && !row.isExternal"> Agent</ion-badge>
          <ion-badge color="success" *ngIf="row.user && !row.user.isExternal && row.isExternal">
            Internal Customer</ion-badge
          >
          <a (click)="changeRole(row)">
            <ion-icon name="chevron-down-outline"></ion-icon>
          </a>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Phone number" prop="phoneNumber" [minWidth]="170">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span> {{row.user?.phoneNumber}} </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Subscribed to Outbounds" [maxWidth]="170" [minWidth]="170" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span *ngIf="row.user && row.user.isUnsubscribed !== false">
            <ion-icon name="checkmark-outline"></ion-icon>
            Subscribed
          </span>
          <span *ngIf="row.user && row.user.isUnsubscribed === false">
            <ion-icon name="close-circle"></ion-icon>
            Unsubscribed
          </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Notes" [sortable]="false" [minWidth]="350">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <a (click)="editMemberNotes(row)" style="margin-left: 5px">
            <ion-icon name="create-outline" class="padded-icon"></ion-icon>
            <i *ngIf="!row.notes">Add notes</i>
          </a>
          <span (click)="editMemberNotes(row)" title="{{row.notes}}">{{row.notes}}</span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Member since" prop="createdAt" [maxWidth]="250" [minWidth]="250">
        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
          {{value | date:'MMM d yyyy h:mm a'}}
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </ion-card>
</ion-content>
